import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { type ActionButton } from '@bizzdesign/shared/models';
import { baseRoutes } from '@bizzdesign/shared/utils';
import { CallToActionComponent } from '@bizzdesign/ui-call-to-action';
import { restoreReplaceUrlFromRoute } from '../utils/restore-replace-url.util';

@Component({
  selector: 'bd-access-denied',
  imports: [CallToActionComponent, SharedI18nModule],
  standalone: true,
  templateUrl: './access-denied.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessDeniedComponent {
  private readonly router = inject(Router);

  readonly actionButton: ActionButton = {
    labelKey: 'errorPage.goHome',
    tScope: 'uiComponents',
    onClick: () => {
      this.router.navigate([baseRoutes.home]);
    },
  };

  constructor() {
    restoreReplaceUrlFromRoute();
  }
}
